import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { apiService } from "../../../../base/utils/service";

class OptionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      field1:
        this.props.gateway.shop_config &&
        this.props.gateway.shop_config.authority_1
          ? this.props.gateway.shop_config.authority_1
          : "",
      field2:
        this.props.gateway.shop_config &&
        this.props.gateway.shop_config.authority_2
          ? this.props.gateway.shop_config.authority_2
          : "",
      field3:
        this.props.gateway.shop_config &&
        this.props.gateway.shop_config.authority_3
          ? this.props.gateway.shop_config.authority_3
          : "",
      shopUid: window.location.pathname.split("/")[2],
      active: this.props.gateway.shop_config
        ? this.props.gateway.shop_config.active
        : true,
    };
  }
  addOptions() {
    this.setState({ pending: true });
    var params = {
      authority_1: this.state.field1,
      authority_2: this.state.field2,
      authority_3: this.state.field3,
      index: 0,
      active: true,
      gateway: this.props.gateway.uid,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/payment-config/gateways`,
      "post",
      params
    ).then((data) => {
      if (data) {
        Swal.fire({
          text: "با موفقیت انجام شد",
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 2000,
          width: 180,
          timerProgressBar: true,
        });
        this.setState({ pending: false });
        this.props.changeModal();
        this.props.optionsChange(data);
      }
    });
  }
  updateOptions() {
    this.setState({ pending: true });
    var params = {
      authority_1: this.state.field1,
      authority_2: this.state.field2,
      authority_3: this.state.field3,
      index: 0,
      active: this.state.active,
      gateway: this.props.gateway.uid,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/payment-config/gateways/${this.props.gateway.shop_config.uid}`,
      "put",
      params
    ).then((data) => {
      if (data) {
        Swal.fire({
          text: "با موفقیت انجام شد",
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 2000,
          width: 180,
          timerProgressBar: true,
        });
        this.setState({ pending: false });
        this.props.changeModal();
        this.props.optionsChange(data);
      }
    });
  }
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.optionsModal}
          toggle={() => this.props.changeModal(!this.props.optionsModal)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0">
              <p className="fw-bold fs-4">{`تنظیمات درگاه ${this.props.gateway.title}`}</p>
              {/* <p className="fw-bold small text-muted mb-4">
                ثبت / تغییر شماره کارتی که به خریداران برای واریز وجه سفارشات
                نمایش داده می شود.
              </p> */}
            </div>
            {this.props.gateway.gateway_config.field_1 && (
              <div className={`col-12 px-0 position-relative`}>
                <textarea
                  value={this.state.field1}
                  rows="2"
                  placeholder={this.props.gateway.gateway_config.field_1}
                  onChange={(e) => this.setState({ field1: e.target.value })}
                  className="w-100 h-100 p-3 rounded14 border-main-1 fw-bold"
                />

                {this.state.field1 && (
                  <span
                    className="position-absolute fs-7 color-main bg-white px-2"
                    style={{ top: "-8px", right: "20px" }}
                  >
                    {this.props.gateway.gateway_config.field_1}
                  </span>
                )}
              </div>
            )}
            {this.props.gateway.gateway_config.field_2 && (
              <div className={`col-12 px-0 position-relative mt-3`}>
                <input
                  value={this.state.field2}
                  placeholder={this.props.gateway.gateway_config.field_2}
                  onChange={(e) => this.setState({ field2: e.target.value })}
                  className="w-100 h-100 p-3 rounded14 border-main-1 fw-bold"
                />

                {this.state.field2 && (
                  <span
                    className="position-absolute fs-7 color-main bg-white px-2"
                    style={{ top: "-8px", right: "20px" }}
                  >
                    {this.props.gateway.gateway_config.field_2}
                  </span>
                )}
              </div>
            )}
            {this.props.gateway.gateway_config.field_3 && (
              <div className={`col-12 px-0 position-relative mt-3`}>
                <input
                  value={this.state.field3}
                  placeholder={this.props.gateway.gateway_config.field_3}
                  onChange={(e) => this.setState({ field3: e.target.value })}
                  className="w-100 h-100 p-3 rounded14 border-main-1 fw-bold"
                />

                {this.state.field3 && (
                  <span
                    className="position-absolute fs-7 color-main bg-white px-2"
                    style={{ top: "-8px", right: "20px" }}
                  >
                    {this.props.gateway.gateway_config.field_3}
                  </span>
                )}
              </div>
            )}
            {this.props.cardError && (
              <span className="text-danger small pe-3 mt-2">
                {this.props.cardError[0].message}
              </span>
            )}
            <div className="col-12 px-0 mt-3">
              <button
                disabled={
                  this.state.pending ||
                  (this.props.gateway.gateway_config.field_1 &&
                  this.props.gateway.gateway_config.field_2 &&
                  this.props.gateway.gateway_config.field_3
                    ? !this.state.field1 ||
                      !this.state.field2 ||
                      !this.state.field3
                    : this.props.gateway.gateway_config.field_1 &&
                      this.props.gateway.gateway_config.field_2 &&
                      !this.props.gateway.gateway_config.field_3
                    ? !this.state.field1 || !this.state.field2
                    : this.props.gateway.gateway_config.field_1 &&
                      !this.props.gateway.gateway_config.field_2 &&
                      !this.props.gateway.gateway_config.field_3 &&
                      !this.state.field1)
                }
                onClick={() =>
                  !this.props.gateway.shop_config
                    ? this.addOptions()
                    : this.updateOptions()
                }
                className="btn bg-color-main bg-disabled text-white fw-bold py-2-3 w-100 rounded28"
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    role="status"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                ) : (
                  "ثبت"
                )}
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default OptionsModal;
